import { useState, useEffect } from "react";
import { FooterNewsletter } from "./FooterNewsletter";

const navLinks = [
  { name: "Pre koho", href: "/#pre-koho" },
  { name: "Služby", href: "/#sluzby" },
  { name: "Výsledky", href: "/#vysledky" },
  { name: "O mne", href: "/#o-mne" },
  { name: "Kontakt", href: "/#kontakt" },
];

const CONTACT_EMAIL = "info@petertej.sk";
const LINKEDIN_URL = "https://linkedin.com/in/peter-tej";

/**
 * Professional footer with identity, navigation and contact.
 * Dark background, no extra photos/icons/forms.
 */
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  useEffect(() => {
    // Show cookie settings link only when non-essential cookies are actually used.
    // Currently managed via the cookie-consent banner (accept/reject).
    setShowCookieSettings(true);
  }, []);

  const openCookieSettings = () => {
    localStorage.removeItem("cookie_consent");
    window.dispatchEvent(new Event("cookie-consent-reset"));
  };

  return (
    <footer className="bg-charcoal text-white/90">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Identity — first on mobile and desktop */}
          <div className="space-y-4">
            <h2 className="font-heading text-2xl text-white">Peter Tej</h2>
            <p className="text-white/70 leading-relaxed max-w-xs">
              Praktická AI pre školy, samosprávy a firmy.
            </p>
          </div>

          {/* Contact — second on mobile, third on desktop */}
          <div className="space-y-4 order-2 md:order-3">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white/60">
              Kontakt
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="text-white/80 hover:text-white underline underline-offset-4 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal rounded-sm"
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={LINKEDIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 hover:text-white underline underline-offset-4 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal rounded-sm"
                >
                  LinkedIn
                </a>
              </li>
              <li className="text-white/70">Bardejov, Slovensko</li>
            </ul>
          </div>

          {/* Navigation — third on mobile, second on desktop */}
          <div className="space-y-4 order-3 md:order-2">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white/60">
              Navigácia
            </h3>
            <nav aria-label="Pätičková navigácia">
              <ul className="space-y-3">
                {navLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-white/80 hover:text-white underline-offset-4 hover:underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal rounded-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        {/* Newsletter */}
        <div className="mt-12">
          <FooterNewsletter />
        </div>

        {/* Bottom row */}
        <div className="mt-12 pt-8 border-t border-white/15">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/60">
            <p>© {currentYear} Peter Tej</p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
              <a
                href="/gdpr"
                className="hover:text-white underline underline-offset-4 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal rounded-sm"
              >
                Ochrana osobných údajov
              </a>
              {showCookieSettings && (
                <button
                  type="button"
                  onClick={openCookieSettings}
                  className="hover:text-white underline underline-offset-4 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal rounded-sm"
                >
                  Nastavenie cookies
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
